// src/contexts/ProductThemeContext.jsx
import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  PRODUCT_THEME_IDS,
  resolveProductThemeFromPath,
} from "../utils/productThemes";

const ProductThemeContext = createContext({
  themeId: PRODUCT_THEME_IDS.SENSAPHONE,
});

export function ProductThemeProvider({ children, themeId: themeIdOverride }) {
  const { pathname } = useLocation();
  const themeId = useMemo(() => {
    if (themeIdOverride) return themeIdOverride;
    return resolveProductThemeFromPath(pathname);
  }, [themeIdOverride, pathname]);

  const value = useMemo(() => ({ themeId }), [themeId]);

  return (
    <ProductThemeContext.Provider value={value}>
      <div data-product-theme={themeId} className="product-theme-root min-h-screen">
        {children}
      </div>
    </ProductThemeContext.Provider>
  );
}

export function useProductTheme() {
  return useContext(ProductThemeContext);
}

export default ProductThemeContext;
